/*
 * "Cargar más productos" en colecciones.
 * Trae la siguiente página con la Section Rendering API y agrega las tarjetas
 * a la cuadrícula, sin perder la posición. Listener delegado: sigue funcionando
 * después de que los filtros (facets.js) vuelven a pintar la cuadrícula.
 * Sin JavaScript, el botón es un enlace normal a la página siguiente.
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-load-more-button]');
  if (!button) return;

  event.preventDefault();
  if (button.getAttribute('aria-busy') === 'true') return;

  button.setAttribute('aria-busy', 'true');
  button.classList.add('loading');

  const url = new URL(button.href, window.location.origin);
  url.searchParams.set('section_id', button.dataset.sectionId);

  try {
    const response = await fetch(url.toString());
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const grid = document.getElementById('product-grid');
    const newItems = Array.from(doc.querySelectorAll('#product-grid > .grid__item'));
    if (!grid || newItems.length === 0) throw new Error('Sin productos nuevos');

    newItems.forEach((item) => {
      // Las animaciones de aparición solo se activan al cargar la página; sin esto
      // las tarjetas nuevas quedarían invisibles.
      item.classList.remove('scroll-trigger', 'animate--slide-in');
      grid.appendChild(item);
    });

    const currentControls = document.querySelector('[data-load-more]');
    const nextControls = doc.querySelector('[data-load-more]');
    if (currentControls) {
      if (nextControls) currentControls.replaceWith(nextControls);
      else currentControls.remove();
    }

    const live = document.querySelector('[data-load-more-live]');
    if (live) {
      const count = newItems.length;
      live.textContent = count === 1 ? 'Se cargó 1 producto más.' : `Se cargaron ${count} productos más.`;
    }

    // Lleva el foco a la primera tarjeta nueva (teclado y lectores de pantalla)
    // sin mover la pantalla.
    newItems[0].querySelector('a')?.focus({ preventScroll: true });
  } catch (error) {
    // Si algo falla, navega a la página siguiente de forma normal.
    window.location.href = button.href;
  }
});
